<script>
    import { uuid } from "../../utils";
    export let color = "rgba(0, 10, 31, 0.3)";
    export let name = "";
    export let size = 16;
    export let label = "";
    const id = uuid();
    const cls = 'sui-icons'
</script>

<svg
    class={`${cls} ${$$props.class || ""}`}
    style:--size={`${size}px`}
    style:--color={color}
    aria-labelledby={id}
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    on:click
    xmlns="http://www.w3.org/2000/svg"
>
    <title {id}>{label || name}</title>
    <slot />
</svg>

<style lang="less">
    @import "./svgo.less";
</style>
